// hooks/useCategorys.js
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createCategory, getCategories, updateCategory, removeCategory } from "services/categories";
import { setCategories } from "store/categorySlice";

const useCategories = () => {
    const categories = useSelector((state) => state.category.categories);

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const dispatch = useDispatch();

    // Fetch Categorys
    const fetchCategories = async (params) => {
        setLoading(true);
        try {
            const data = await getCategories(params);

            dispatch(setCategories(data));
            return data;
        } catch (err) {
            setError(err.message || "Failed to fetch Categorys");
        } finally {
            setLoading(false);
        }
    };

    // Create Category
    const addCategory = async (newCategory) => {
        setLoading(true);
        try {
            const response = await createCategory(newCategory);
            fetchCategories();
            return response;
        } catch (err) {
            setError(err.response.data.message || "Failed to create Category");
            return err;
        } finally {
            setLoading(false);
        }
    };

    // Edit Category
    const editCategory = async (updatedData) => {
        setLoading(true);
        try {
            const updated = await updateCategory(updatedData);

            fetchCategories();

            return updated;
        } catch (err) {
            setError(err.response?.data?.message || err.message || "فشل تعديل القسم");
            return err;
        } finally {
            setLoading(false);
        }
    };

    // Delete Category
    const deleteCategory = async (id) => {
        setLoading(true);
        try {
            await removeCategory(id);
            return true;
        } catch (err) {
            setError(err.message || "Failed to delete Category");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCategories();
    }, []);

    return {
        categories,
        loading,
        error,
        fetchCategories,
        addCategory,
        editCategory,
        deleteCategory,
    };
};

export default useCategories;
